<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="description" content="" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link
        href="https://fonts.googleapis.com/css?family=Lato:300,400,700"
        rel="stylesheet"
        type="text/css"
      />
    </head>
    <v-layout
      class="mt-5"
      v-if="isloading"
      align-center="align-center"
      justify-center="justify-center"
      column="column"
      fill-height="fill-height"
    >
      <v-progress-circular
        size="70"
        width="7"
        color="purple"
        indeterminate="indeterminate"
      ></v-progress-circular>
      <div>Loading...</div>
    </v-layout>

    <body v-if="!isloading">
      <div class="customLogo" v-if="invoice.paidDateTime">
        <img src="../../../assets/paidImg.png" />
      </div>
      <div class="header-container">
        <header class="wrapper clearfix">
          <h1 class="text-primary pull-left mt-3">INVOICE</h1>
          <div class="pull-right">
            <div class="contact">
              <p>31 South St Suite 3S6 Mount Vernon, NY 10550</p>
              <p>Tel: 347-391-2600</p>
              <p>Email: info@cellsmartpos.com</p>
            </div>
            <div class="logo"><img src="../../../assets/cspLogo-2.png" /></div>
          </div>
        </header>
      </div>
      <div class="main-container">
        <div class="top wrapper clearfix">
          <div class="invoice-top clearfix">
            <div class="pull-left">
              <small>Bill to</small>
              <h2 class="client-name">{{ invoice.Store.businessName }}</h2>
              <hr class="separator" />
              <div class="address">
                <p>{{ invoice.Store.address }}</p>
                <p>{{ invoice.Store.businessPhone }}</p>
                <p>{{ invoice.Store.invoiceEmail }}</p>
              </div>
            </div>
            <div class="pull-right">
              <div v-if="invoice.paidDateTime">
                <p>
                  <span class="label bg-primary mr-1">Payment Method</span>
                  <v-template v-if="invoice.paymentTypeID == 59 || invoice.paymentTypeID == 1">
                    <b>Cash</b>
                    <P
                      ><span class="label bg-primary mr-1">TransactionID</span
                      ><b>{{ invoice.stripePaymentID }}</b></P
                    >
                  </v-template>
                  <v-template v-else-if="invoice.paymentTypeID == 60 || invoice.paymentTypeID == 2"
                    ><b>Stripe</b>
                    <P
                      ><span class="label bg-primary mr-1">StripeID</span
                      ><b>{{ invoice.stripePaymentID }}</b></P
                    >
                  </v-template>
                  <v-template v-else-if="invoice.paymentTypeID == 61 || invoice.paymentTypeID == 3">
                    <b>ACH</b></v-template
                  >
                  <v-template v-else-if="invoice.paymentTypeID == 62 || invoice.paymentTypeID == 4">
                    <b>Credit Card</b></v-template
                  >
                  <v-template v-else-if="invoice.paymentTypeID == 63 || invoice.paymentTypeID == 5">
                    <b>Bank Deposit</b></v-template
                  >
                  <v-template v-else-if="invoice.paymentTypeID == 95 || invoice.paymentTypeID == 6">
                    <b>Free</b></v-template
                  >
                </p>
              </div>
              <p>
                <span class="label bg-primary mr-1">Invoice #</span><b>{{ invoice.invoiceID }}</b>
              </p>
              <p>
                <span class="label bg-gray mr-1">CSP ID</span><b> {{ invoice.Store.CSPID }}</b>
              </p>
              <p>
                <span class="label bg-gray mr-1">Invoice Date</span
                ><b>{{ $moment(invoice.createDateTime).format("ddd, DD MMM YYYY") }}</b>
              </p>
              <p>
                <span class="label bg-primary mr-1">Charge Date</span
                ><b>{{ $moment(invoice.chargeDateTime).format("ddd, DD MMM YYYY") }} </b>
              </p>
              <p v-if="invoice.paidDateTime">
                <span class="label bg-primary mr-1">Paid Date</span
                ><b>{{ $moment(invoice.paidDateTime).format("ddd, DD MMM YYYY") }} </b>
              </p>
              <hr class="separator" />
              <h2 class="amount">TOTAL AMOUNT</h2>
              <p class="price currency">
                {{ (invoice.invoiceAmount + invoice.taxAmount) | currency }}
              </p>
            </div>
          </div>
        </div>
        <div class="main wrapper clearfix">
          <div class="table-responsive">
            <table class="price-table">
              <thead>
                <tr>
                  <th class="nowrap aling-left">ITEM DESCRIPTION</th>
                  <th class="nowrap">UNIT PRICE</th>
                  <th>QUANTITY</th>
                  <th>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in invoice.InvoiceDetails">
                  <td class="description-column">
                    <h4>{{ row.productDetail }}</h4>
                    <span
                      >{{ row.Product.description }}
                      <p v-if="row.Product.productType === 'RENEW'">
                        <b>{{ row.givenDay }} Days Given</b>
                      </p>
                      <p v-else="v-else">
                        Serial # :<b>{{ row.hardwareSerial }}</b>
                      </p></span
                    >
                  </td>
                  <td class="price-column">
                    <span class="price currency pull-right">{{ row.rate | currency }}</span>
                  </td>
                  <td class="quantity-column">
                    <span class="price">{{ row.qty }}</span>
                  </td>
                  <td class="total-column">
                    <span class="price currency pull-right">{{ row.total | currency }} </span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2">&nbsp;</td>
                  <td>SUBTOTAL</td>
                  <td class="nowrap currency">{{ invoice.invoiceAmount | currency }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                  <td class="nowrap">TAX ({{ invoice.taxRate }}%)</td>
                  <td class="nowrap currency">{{ invoice.taxAmount | currency }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                  <td class="nowrap">AMOUNT DUE</td>
                  <td class="nowrap currency">
                    {{ parseFloat(invoice.invoiceAmount) + parseFloat(invoice.taxAmount) | currency }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="footer-container">
          <footer class="wrapper">
            <div class="clearfix"></div>
            <hr />
            <p>
              Please know that we are 100% committed to providing you with the best customer service
              possible. Should you need anything, whether it's understanding the software or
              installing your hardware - we would be delighted to hear from you. If you have any
              questions or need any assistance, please feel free to call us at 347-391-2600.
            </p>
          </footer>
        </div>
      </div>
    </body>
  </html>
</template>

<script>
import globalService from "../service.js";
export default {
  name: "view-invoice",
  data() {
    return {
      isloading: true,
      invoice: null
    };
  },
  mounted() {
    globalService.getInvoiceById(this.$route.params).then(result => {
      console.log("result is .....", result);
      this.invoice = result.data;
      this.isloading = false;
    });
    // console.log('this.$route.params', this.$route.params)
  }
};
</script>
<style scoped>
/*! HTML5 Boilerplate v4.3.0 | MIT License | http://h5bp.com/ */
.amount,
.price {
  text-align: right;
}
.nowrap,
.price {
  white-space: nowrap;
}
html {
  font-size: 1em;
  line-height: 1.4;
}
.browsehappy {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}
.header-container,
.invoice-top h2 {
  margin-bottom: 10px;
}
body {
  font: 16px/26px Lato, Helvetica, "Helvetica Neue", Arial;
  color: #666;
}
.label,
.price {
  font-weight: 700;
}
h1 {
  font-size: 3em;
}
.wrapper {
  padding: 0 20px;
}
.top {
  padding: 20px;
}
.invoice-top {
  background: #f8f8f9;
  padding: 10px;
  border-left: 3px solid transparent;
}
.invoice-top h2 {
  font-size: 1.8em;
  margin-top: 1px;
  padding-top: 10px;
}
.invoice-top p {
  margin: 0;
}
.separator {
  border-top: 1px dotted #ccc;
  border-bottom: 0;
  margin: 5px;
}
.price {
  font-size: 1.7em;
}
.label {
  color: #fff;
  font-size: 0.8em;
  border-radius: 4px;
  padding: 3px;
}
.contact {
  font-weight: 300;
  margin: 0.67em 0;
  float: left;
}
.contact p,
.description-column h4 {
  margin: 0;
}
.logo {
  float: right;
  padding: 0.67em;
}
.logo img {
  height: 70px;
}
.customLogo {
  position: fixed;
  top: 15%;
  left: 25%;
}
.main {
  padding: 30px 20px;
  background: #fafafa;
}
.price-table {
  width: 100%;
  border: 0;
  border-collapse: collapse;
}
.price-table > thead th {
  padding: 20px;
  font-size: 1.3em;
  background: #fafbfb;
  border: 1px solid #f4f4f4;
  border-right: 1px solid #ddd;
}
.price-table > tbody td:last-child,
.price-table > thead th:last-child {
  border-right: 1px solid #f4f4f4;
}
.price-table > tbody td {
  padding: 5px 20px;
  border-right: 1px solid #ddd;
}
.price-table > tbody tr:nth-child(4n + 1) {
  background: #fff;
}
.price-table > tfoot td:nth-child(2),
.price-table > thead th:first-child {
  border-left: 3px solid transparent;
}
.price-table > tbody > tr:nth-child(4n + 1) td:first-child {
  border-left: 3px solid #354344;
}
.price-table > tbody > tr:nth-child(4n + 3) td:first-child {
  border-left: 3px solid transparent;
}
.price-table > tfoot td:nth-child(n + 2) {
  background: #fff;
  padding: 4px 20px;
}
.price-table > tfoot td:last-child {
  font-weight: 700;
  text-align: right;
}
.description-column {
  text-align: left;
}
.quantity-column {
  text-align: center;
}
.quantity-column .label {
  font-size: 1.7em;
}
.spacer {
  border-top: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
}
.spacer:last-child {
  border-bottom: 0;
}
.spacer td {
  padding: 2px 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
}
.footer-container footer {
  padding: 20px;
}
.footer-container footer h3 {
  margin: 2px;
}
.payment {
  float: left;
  margin-left: 15px;
}
.signature {
  height: 50px;
}
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}
.align-left {
  text-align: left;
}
.align-right {
  text-align: right;
}
.align-center {
  text-align: center;
}
.main article h1 {
  font-size: 2em;
}
.clearfix:after,
.clearfix:before {
  content: " ";
  display: table;
}
.clearfix:after {
  clear: both;
}
@media only screen and (max-width: 480px) {
  .payment {
    float: none;
  }
}
@media only screen and (max-width: 768px) {
  .invoice-top h2,
  .top {
    padding-top: 0;
  }
  #payment-method,
  .amount,
  .price {
    text-align: left;
  }
  h1 {
    font-size: 2em;
    margin-bottom: 35px;
  }
  .invoice-top h2,
  .price,
  .quantity-column .label {
    font-size: 1.2em;
  }
  .invoice-top .pull-left,
  .table-responsive {
    margin-bottom: 15px;
  }
  .logo {
    position: absolute;
    top: 0;
    right: 0;
  }
  .price-table > thead th {
    font-size: 1em;
    padding: 10px;
  }
  .price-table > tbody td {
    padding: 5px 10px;
  }
  .description-column {
    font-size: 0.8em;
  }
  .pull-left,
  .pull-right {
    float: none;
  }
  .table-responsive {
    width: 100%;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
}
@media only screen and (min-width: 1140px) {
  .wrapper {
    width: 1026px;
    margin: 0 auto;
  }
}
@media print {
  blockquote,
  img,
  pre,
  tr {
    page-break-inside: avoid;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
  a,
  a:visited {
    text-decoration: underline;
  }
  a[href]:after {
    content: " (" attr(href) ")";
  }
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  .ir a:after,
  a[href^="javascript:"]:after,
  a[href^="#"]:after {
    content: "";
  }
  blockquote,
  pre {
    border: 1px solid #999;
  }
  thead {
    display: table-header-group;
  }
  img {
    max-width: 100% !important;
  }
  @page {
    margin: 0.5cm;
  }
  h2,
  h3,
  p {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
}
.text-primary {
  color: #f05323;
}

.bg-primary {
  background: #f05323;
}

.gray {
  color: #354344;
}

.bg-gray {
  background: #354344;
}

.price-table > tfoot td:nth-child(2),
.invoice-top,
.price-table > thead th:first-child,
.price-table > tbody > tr:nth-child(4n + 3) td:first-child {
  border-left-color: #f05323;
}
</style>
